import { render, staticRenderFns } from "./Play-Video.vue?vue&type=template&id=1876e2fd&scoped=true&"
import script from "./Play-Video.vue?vue&type=script&lang=js&"
export * from "./Play-Video.vue?vue&type=script&lang=js&"
import style0 from "./Play-Video.vue?vue&type=style&index=0&id=1876e2fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1876e2fd",
  null
  
)

export default component.exports